module.exports = __webpack_public_path__ + "img/0-7.dc80d666.gif";